import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from '../../utils/axios';

export const getBrands = createAsyncThunk("get/brand", async () => {
  const response = await axios.get("/brand/");
  return response.data;
});

export const addBrand = createAsyncThunk("add/brand", async (brand, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post("/brand/", brand);
    dispatch(getBrands());
    return response.data;
  } catch (error) {
    return rejectWithValue(error)
  }
});

export const updateBrand = createAsyncThunk("update/brand", async ({ brand, brandData }, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put(`/brand/${brand}/`, brandData);
    dispatch(getBrands());
    return response.data;
  } catch (error) {
    return rejectWithValue(error)
  }
});

export const deleteBrand = createAsyncThunk("delete/brand", async (brandId, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/brand/${brandId}/`);
    dispatch(getBrands());
    return response.data;
  } catch (error) {
    return
  }
});

export const deleteManyBrands = createAsyncThunk("deleteMany/brand", async (brandIDs, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete("/brand/delete_many/", { data: { arrId: brandIDs } });
    dispatch(getBrands());
    return response.data;
  } catch (error) {
    return rejectWithValue(error)
  }
})

const brandAdapter = createEntityAdapter({});

const brandSlice = createSlice({
  name: "brands",
  initialState: brandAdapter.getInitialState({
    brands: [],
    searchText: "",
    routeParams: {},
    loading: false,
    isSubmitting: false,

  }),
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: {

    [getBrands.pending]: (state) => {
      state.loading = true;
    },
    [getBrands.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.brands = data;
      state.loading = false;
    },
    [getBrands.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------------
    [addBrand.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addBrand.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addBrand.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [updateBrand.pending]: (state) => {
      state.isSubmitting = true;
    },
   
    [updateBrand.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [updateBrand.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [deleteBrand.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteBrand.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteBrand.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [deleteManyBrands.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyBrands.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyBrands.rejected]: (state) => {
      state.isSubmitting = false;
    }
  },
});

export const {
  setSearchText,
} = brandSlice.actions;

export default brandSlice.reducer;
